import { ErrorBoundary, Shadow } from '@genial/components';
import { BoxBorder, Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { RouteProp, useRoute } from '@react-navigation/native';
import { Box, Center, FlatList } from 'native-base';
import React from 'react';

import { useRecoilQuery } from '../../../../../../../../hooks/useRecoilQuery';
import { CustomerDetailStackParamList } from '../../../../../../../../routes/types';
import { brokerageInvoicesQuery } from '../../../../../../../../store/customerDetail/reports/selectors';
import { Skeleton } from '../../Skeleton';
import { Item } from '../Item';

interface ListProps {}

export const List: React.FC<ListProps> = () => {
  const viewportType = useBreakpointValue({ sm: 'tablet', lg: 'desktop' });
  const { params } = useRoute<RouteProp<CustomerDetailStackParamList, 'CustomerDetail'>>();

  const accountNumber = params?.accountNumber;

  const { data, loading, error, refresher } = useRecoilQuery(
    brokerageInvoicesQuery({ accountNumber })
  );

  if (loading) {
    return (
      <Shadow
        borderRadius={BoxBorder.heavy}
        mx={{ base: Spacing['inline.xxxs'], md: Spacing['inline.xxxs'] }}
        mb={Spacing['inline.xxs']}
        level={3}>
        <Skeleton viewportType={viewportType} renderCount={8} />
      </Shadow>
    );
  }

  if (error) {
    return (
      <Center h={'400px'}>
        <ErrorBoundary onRefresh={refresher} />
      </Center>
    );
  }

  if (!loading && data && data.length === 0) {
    return (
      <Center h={'400px'}>
        <ErrorBoundary
          errorIconOrIllustration="NotFoundIllustration"
          errorTitle="Nenhum resultado corresponde à sua pesquisa"
          errorMessage="Por favor, verifique o campo informado e tente novamente."
        />
      </Center>
    );
  }

  return (
    <Shadow level={3} mb={Spacing['inline.xxs']}>
      <FlatList
        data={data}
        maxH={700}
        keyExtractor={(item, index) => `${item.brokerageInvoiceDate}-${index}`}
        showsVerticalScrollIndicator={false}
        ItemSeparatorComponent={() => <Box h={Spacing['inline.xxxs']} />}
        renderItem={({ item }) => <Item item={item} />}
      />
    </Shadow>
  );
};
